import { useEffect, useState } from 'react';
import { useApi } from './api';
import { useWorkspace } from './workspace';

/**
 * Returns the set of platform_user_ids the current user is allowed to see in reports.
 *
 * - admin / super_admin  → null              (no restriction — show all)
 * - manager (has team)   → Set of subordinate ids plus own id (team + self)
 * - leaf member          → Set containing only own id
 */
export function useReportScope(appId) {
  const api = useApi();
  const { myRole, me } = useWorkspace();
  const isAdmin = myRole === 'super_admin' || myRole === 'admin';

  const [scopeIds, setScopeIds]   = useState(undefined); // undefined = loading
  const [isManager, setIsManager] = useState(false);

  useEffect(() => {
    if (isAdmin) { setScopeIds(null); setIsManager(false); return; }
    if (!me?.id) return;

    api.getMySubordinateIds(appId)
      .then(r => {
        const ids = r.ids || [];
        if (ids.length > 0) {
          // Manager: show subordinates' data plus own data
          setScopeIds(new Set([...ids, me.id].map(String)));
          setIsManager(true);
        } else {
          // Leaf member: show only own data
          setScopeIds(new Set([String(me.id)]));
          setIsManager(false);
        }
      })
      .catch(() => {
        setScopeIds(new Set([String(me.id)]));
        setIsManager(false);
      });
  }, [appId, isAdmin, me?.id]);

  return { isAdmin, scopeIds, isManager, scopeLoading: scopeIds === undefined };
}